import styled, {
  css,
} from 'styled-components';
import {
  transparentize,
} from 'polished';
import TextareaAutosize from 'react-textarea-autosize';

export const getTextareaStyles = (props: InputProps) => {
  const { colors } = props.theme;
  const getFocusShadowColor = () => {
    if (props.iserror) return 'rgba(255, 86, 10, 0.25)';
    if (props.nonShadow) return 'none';
    return transparentize(0.75, colors.primary);
  };

  const getPlaceholderStyle = () => css`
    color: ${props.placeholdercolor || '#c1c1c1'};
    font-size: 1em;
    opacity: 1;
  `;

  return css`
    color: #797979;
    font-size: 16px;
    font-weight: 400;
    display: flex;
    flex: 0 0 auto;
    width: 100%;
    outline: none;
    resize: none;
    overflow: hidden;
    overflow-wrap: break-word;
    border: solid 1px #cbd4d7;
    border-radius: 5px;
    padding: 10px;
    -moz-tab-size: 8;
    tab-size: 8;
    box-sizing: border-box;

    &::-ms-expand {
      background-color: transparent;
      border: 0;
    }

    &:focus {
      outline: 0;
      box-shadow: 0 0 0 0.2rem ${getFocusShadowColor};
      border-color: ${(props.iserror ? colors.danger : colors.primary)};
      background-color: #fff;
    }

    &::-webkit-input-placeholder {
      ${getPlaceholderStyle}
    }

    &::-moz-placeholder {
      ${getPlaceholderStyle}
    }

    &:-ms-input-placeholder {
      ${getPlaceholderStyle}
    }

    &::-ms-input-placeholder {
      ${getPlaceholderStyle}
    }

    &::placeholder {
      ${getPlaceholderStyle}
    }

    &:disabled,
    &[readonly] {
      opacity: 1;
      background-color: #e9ecef;
      cursor: not-allowed;
    }
  `;
};

export const TextareaContainer = styled(TextareaAutosize)`
  ${getTextareaStyles}
`;
